import { useRunOnce } from '@fabric-app/hooks/useRunOnce';
import { getLocalFileSyncTenantId } from '../utils/getLocalFileSyncTenantId';
import { useState } from 'react';
import { isDesktopApp } from '@todesktop/client-core/platform/todesktop';

import { app } from '@todesktop/client-core';
import { isDesktopFileSyncSupportedToDesktopVersion } from '../utils/isDesktopFileSyncSupportedToDesktopVersion';
import { captureException } from '@fabric-app/compat/capabilities/sentry';

export const useDesktopFileSyncTenantId = () => {
  const [tenantId, setTenantId] = useState<string | null>(null);

  useRunOnce(
    async () => {
      const desktopAppVersion = app.getVersion();

      if (isDesktopFileSyncSupportedToDesktopVersion(desktopAppVersion)) {
        const tenantId = await getLocalFileSyncTenantId();
        setTenantId(tenantId);

        if (!tenantId) {
          captureException(new Error('Desktop file sync tenant id not available'), {
            extra: {
              desktopAppVersion,
            },
          });
        }
      }
    },
    {
      condition: isDesktopApp(),
    },
  );

  return tenantId;
};
